export const ScrollingElement = document.scrollingElement || document.body;

export const PanelHeight = {
    open: 146,
    closed: 100,
};
